<script setup lang="ts">
import SimpleModal from "@/components/Modals/SimpleModal.vue";
import DefaultButton from "@/components/Buttons/DefaultButton.vue";

type Props = {
  visible: boolean;
};

defineProps<Props>();
const emit = defineEmits<{ (e: "close"): void }>();
</script>

<template>
  <SimpleModal :visible="visible" @close="emit('close')">
    <div class="p-4 text-center">
      <!-- Fun badge/icon -->
      <div
        class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border-2 border-black-dark bg-kekkle-yellow text-3xl shadow-yellow-hard-sm"
      >
        🎬
      </div>

      <h3 class="mb-2 text-xl font-black text-gray-900 dark:text-white">
        {{ $t("pages.shorts.app_only_title") }}
      </h3>

      <p class="mb-6 text-sm text-gray-600 dark:text-gray-300">
        {{ $t("pages.shorts.app_only_description") }}
      </p>

      <!-- App Store Links -->
      <div class="flex flex-col gap-3">
        <a
          href="https://apps.apple.com/app/kekkle/id6450749916"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center justify-center gap-3 rounded-xl border-2 border-black-dark bg-black-dark px-4 py-2.5 font-bold text-white shadow-teal-hard-sm transition-all hover:brightness-110 active:translate-x-[2px] active:translate-y-[2px] active:shadow-none"
        >
          <span class="text-xl">🍏</span>
          <span>{{ $t("pages.shorts.download_ios") }}</span>
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=nl.kekkle.app"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center justify-center gap-3 rounded-xl border-2 border-black-dark bg-kekkle-blue px-4 py-2.5 font-bold text-gray-900 shadow-teal-hard-sm transition-all hover:brightness-110 active:translate-x-[2px] active:translate-y-[2px] active:shadow-none"
        >
          <span class="text-xl">🤖</span>
          <span>{{ $t("pages.shorts.download_android") }}</span>
        </a>
      </div>

      <div class="mt-4">
        <DefaultButton color="blue" :full-width="true" @click="emit('close')">
          {{ $t("global.buttons.cancel") }}
        </DefaultButton>
      </div>
    </div>
  </SimpleModal>
</template>
